var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        no: "sendDestinationPortAgent",
        visible: _vm.innerVisible,
        title: _vm.$t("FileHistory.SendDestinationPortAgent"),
        width: "600px",
        "close-on-click-modal": false,
        "append-to-body": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("span", [
        _vm._v(
          _vm._s(
            _vm.$t("CargoMsg.Cargo_MatchInstructionTip", [
              _vm.total,
              _vm.jobCount
            ])
          )
        )
      ]),
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", "min-height": "350px" },
        attrs: {
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData
        }
      }),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "SendEmail", type: "primary" },
              on: { click: _vm.onSendEmail }
            },
            [_vm._v(_vm._s(_vm.$t("FileHistory.SendEmail")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "Cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }